// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"11f86de4","945":"39cf18cf"}[chunkId] + ".chunk.js";
};